import {getAxios, formDataToRequestParams} from './axios'
import {addAuthTokenData} from './member';

export function sendContactMessage(formData) {
    let axios = getAxios({forcedSSL: true});

    return axios.request({
        url: '/contact/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData(formData))
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/contacts.js